// /s/$id — real route (design doc's G1/G4, public/SEO surface). Mirrors
// apps/web's app/s/[id]/page.tsx: a `'use client'` page reading its own `id`
// via next/navigation's useParams() (shimmed onto TanStack params), so it's
// lazy-imported directly per the porting convention (route-helpers.tsx) —
// same pattern as routes/canvas-detail.tsx. No guard: replaces the
// placeholderRoute call in routes/core.tsx (public, no `_authed`/`_admin`
// wrap — ClientLayout already renders `/s/` chromeless).
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

const SharedChatPage = lazy(() => import('@/app/s/[id]/page'));

export const shareSessionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/s/$id',
  component: SharedChatPage,
});
